import React, { Suspense } from "react";
import Space from "./ui/Space";
import SpaceLoader from "./ui/SpaceLoader";
import Navigation from "./ui/Navigation";
import { Route, Switch } from "react-router-dom";
import Loader from "./components/Loader";
import Home from "./ui/Home";
import Bug from "./ui/Bug";
import Onboarding from "./ui/user/Onboarding";
import { styled } from "./stitches.config";
import LoggedInRoute from "./ui/LoggedInRoute";
import BigSpaceList from "./ui/BigSpaceList";
import { RoomServiceProvider } from "@roomservice/react";

function App() {
  return (
    <>
      <Backdrop />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <LoggedInRoute exact path="/login"></LoggedInRoute>
        <Route exact path="/spaces">
          <Suspense fallback={<Loader>Loading space...</Loader>}>
            <Onboarding>
              <RoomServiceProvider
                clientParameters={{
                  auth: `/api/roomservice/?user=${"null"}`,
                }}
              >
                <BigSpaceList />
              </RoomServiceProvider>
            </Onboarding>
          </Suspense>
        </Route>
        <Route path="/space/:spaceId">
          <Suspense fallback={<Loader>Loading space...</Loader>}>
            <Onboarding>
              <SpaceLoader>
                <Navigation />
                <Space />
              </SpaceLoader>
            </Onboarding>
          </Suspense>
        </Route>
      </Switch>
      <Bug />
    </>
  );
}

export default App;

const Backdrop = styled("div", {
  position: "fixed",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  zIndex: -99999,
  background: "$beige",
});
